import { GetServerSidePropsContext } from 'next';

/**
 * Method to identify if it's the initial load (page refresh, navigating from another domain)
 * or if it's incremental (navigating through a link or browser forward/back)
 * Not listed in the official docs, could break on next versions - if you know a better solution please reach out
 */
export const getIsInitialLoad = (context: GetServerSidePropsContext) =>
    !context.req.url?.includes('/_next/data');
